<template>
  <div>
    <v-flex
      :class="['label','p-0', {'custom-error-color': validator && validator.$error}]"
    >
      <span>{{ label }}</span>
    </v-flex>
    <v-layout column>
      <v-layout row>
        <v-flex
          v-for="zone in parseInt(numberOfZones)"
          :key="zone.toString()"
          :class="{ 'secondary zone-selected': isSelected(zone) }"
          shrink
          class="zone field-icon"
          @click="toggleZone(zone)"
        >
          <div class="size-32 zone-content text-center">{{ zone }}</div>
        </v-flex>
      </v-layout>
      <v-flex style="position: relative;">
        <div
          style="padding:0px;"
          :class="['custom-error-message', {'error--text': validator && validator.$error}]"
        >
          <span> {{ getErrors(validator)[0] }} &nbsp;</span>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'

import { defaultMessages, getValidationErrors } from './../../../utils'

export default {
  mixins: [AdminContext],
  name: 'zone-picker-field',
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Array,
      default: ()=> [],
    },
    numberOfZones: {
      type: Number,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
  },
  watch: {
    numberOfZones: {
      handler(numberOfZones) {
        const zones = (this.value || []).filter(z => z <= numberOfZones)
        this.$emit('input', zones)
      },
      immediate: true,
    },
  },
  methods: {
    isSelected(zone) {
      return (this.value || []).includes(zone)
    },
    getErrors: function(field){
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.adminFieldValidationMessages(this.errorMessages),
      })(field)
    },
    toggleZone(zone) {
      this.validator && this.validator.$touch()
      const index = this.value.indexOf(zone)
      if (index === -1) {
        this.$emit('input', [...this.value, zone])
      } else {
        const before = this.value.slice(0, index)
        const after = this.value.slice(index+1)
        const zones = [...before, ...after]
        this.$emit('input', zones)
      }
    },
  },
}
</script>

<style>
.zone:hover {
  background-color: rgba(255, 76, 0, 0.2);
}
.zone-selected div {
  color: white;
}
.zone-content {
  font-family: 'Source Sans Pro';
  font-size: 20px;
  font-weight: bold;
  color: #ff4c00;
}
.zone {
  cursor: pointer;
  margin-right: 4px !important;
  font-weight: bold;
  border-radius: 100% !important;
}
.field-icon {
  margin-top: 8px !important;
}
.label {
  line-height: 16px;
  font-size: 16px;
  color: #979797;
}

@keyframes error-msg-animation {
  0% {
    top: -15px;
  }
  100% {
    top: -2px;
  }
}

@keyframes label-error-animation {
  0% {
    right: 5px;
  }
  25%,
  75% {
    right: 0;
    left: 5px;
  }
  50% {
    left: 0;
    right: 5px;
  }
  100% {
    right: 0;
    left: 0;
  }
}

.error-animation {
  position: absolute;
  top: -2px;
  animation-name: error-msg-animation;
  animation-timing-function: ease-out;
  /* animation-iteration-count: infinite; */
  animation-duration: 0.15s;
}
</style>
